module.exports = __webpack_public_path__ + "static/media/ionicons.ee5b17df.svg";